// ALl countries with special commerce features
// https://cellsignal.atlassian.net/wiki/spaces/ITWEB/pages/3157393412/Pricing+and+Checkout+on+the+Web
export const specialCommerceEnabledCountries = ['US', 'USA', 'DE', 'AT', 'JP', 'GB']

export const vatCountries = ['GB', 'DE', 'AT']

export const usInventoryChannels = [
  'a3a70d81-4943-4130-a59e-c2485c9677a6',
  '55ffcc88-9cd4-430c-a570-e36f403629b8',
  '456098c2-bd84-45a8-8b2f-5e01676d368a',
  '17134f3e-542a-499b-b69c-597b874df675',
]

export const nlInventoryChannels = [
  '27bfbbaa-d206-4ada-bb8f-fbfbadc2c269',
  'cafc1b14-6f15-4e2b-bbf7-e5425e3df325',
  '6be51d9c-471d-4a26-ac87-9f76a6871e2e',
  'c6497fe6-519a-4a39-a0b8-3da386e224a5',
]
